module.exports = __webpack_public_path__ + "static/media/offerBg2.5f2749b9.svg";